<ng-container *transloco="let t; scope: 'catalog'">
  <div class="default-max-width centered detail-page" *ngIf="config" id="topOfArticleList">
    <div class="headline-third bold margin--top-xl margin--bottom-l">
      {{ t("catalog.product-article-list.hits", { hits: totalHits }) }}
    </div>

    <!--
    <button class="listing-sort-mobile js-filters-mobile-open" (click)="openFilterSideNav()">
      <i class="icon-filter"></i>
    </button>
    -->

    <app-product-filter
      id="filters"
      [facets]="facets"
      [product]="product"
      [totalHits]="totalHits"
      (facetChanged)="resetPagination()"
    ></app-product-filter>

    <div class="article-header">
      <div class="listing-sort-icons">
        <button [class.active]="viewMode === 'grid'" (click)="changeViewMode('grid')">
          <i class="icon-grid"></i>
        </button>
        <button [class.active]="viewMode === 'list'" (click)="changeViewMode('list')">
          <i class="icon-list"></i>
        </button>
      </div>

      <div class="sort-container">
        <mat-form-field>
          <mat-label>{{ t("catalog.product-article-list.sort-order") }}</mat-label>
          <mat-select *ngIf="sortBy$ | async as sortBy" [ngModel]="sortBy" (ngModelChange)="sortByChange($event)">
            <mat-option *ngFor="let sort of sortOptions" [value]="sort.key">{{ t(sort.value) }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div
      class="grid__item listing-item"
      [ngClass]="{
        'one-third palm--one-whole small-desk--one-half': viewMode === 'grid',
        'one-whole': viewMode === 'list'
      }"
      *ngFor="
        let articlesList of articles
          | paginate
            : {
                id: config!.id,
                itemsPerPage: config!.itemsPerPage,
                currentPage: config!.currentPage + 1,
                totalItems: totalHits!
              }
      "
    >
      <app-article-item
        class="card-product card-product--no-mobile-config"
        [article]="articlesList"
        [product]="product"
        [viewMode]="$any(viewMode)"
        (alternativeArticleSelected)="selectAlternativeArticle($event)"
      >
      </app-article-item>
    </div>
    <ng-container *ngIf="totalHits! > 16">
      <app-pagination [config]="config" (onPageChange)="changeCurrentPage($event)"></app-pagination>
    </ng-container>
  </div>
</ng-container>
